import script from "./SearchHome.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchHome.vue?vue&type=script&setup=true&lang=js"

import "./SearchHome.vue?vue&type=style&index=0&id=36d1dd28&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d1dd28"]])

export default __exports__